import { getLinks } from "../../../../shared/functions/fns.nav";
import { Header } from "@phoenixreisen/reacts/src/header";
import React, { useEffect, useState } from "react";
import NavToggle from "./navigation.toggle.r";
export const HeaderView = (props) => {
    var _a;
    const { noNav, noImg } = props;
    const { ShortNav, SideNav } = props;
    const { logoUrl, headline, version } = props;
    const [links, setLinks] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        getLinks()
            .then((links) => setLinks(links))
            .catch((error) => setError(error));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "header" },
            React.createElement("div", { className: "wrapper wrapper--large relative" },
                !noNav && ShortNav && React.createElement(ShortNav, null),
                !noNav && SideNav && (React.createElement(NavToggle, { Nav: SideNav, links: links, error: error })),
                React.createElement(Header, { version: version, url: (_a = logoUrl !== null && logoUrl !== void 0 ? logoUrl : links === null || links === void 0 ? void 0 : links.LOGO.href) !== null && _a !== void 0 ? _a : null }))),
        !noImg && (React.createElement("article", { className: "no-img-headline" },
            React.createElement("div", { className: "wrapper wrapper--large" },
                React.createElement("h1", null,
                    React.createElement("i", { className: "fas fa-ship mr2" }),
                    React.createElement("span", null, headline)),
                React.createElement("hr", null)))),
        noImg && headline && (React.createElement("div", { className: "wrapper wrapper--large" },
            React.createElement("h1", null, headline),
            React.createElement("hr", null)))));
};
export default HeaderView;
